/**
 * תיאור מפורט (טקסט/HTML/קישור) אחרי getOrgTourInfo — לשימוש ב-warning בעמוד תשלום בלבד.
 * @param {unknown} res — גוף תשובת ה-API
 */
export function orgTourInfoResponseHasRichDescription(res) {
  if (!res || res.ok === false) return false;
  const t = String(res.contentText || "").trim();
  if (t.length > 40) return true;
  if (String(res.resourceUrl || "").trim().length > 0) return true;
  const h = String(res.contentHtmlSanitized || "").trim();
  if (h.length > 80) return true;
  return false;
}
